import axios from "axios";
import { API, BEARER } from "../constant";
import { getToken } from "../helpers";

export const getCategories = async () => {
  let url = `/word/categories`;

  return await axios
    .get(`${API}${url}`)
    .then((res) => res)
    .catch((err) => console.error(err));
};

export const getTypes = async () => {
  let url = `/word/types`;

  return await axios
    .get(`${API}${url}`)
    .then((res) => res)
    .catch((err) => console.error(err));
};

export const getWords = async ({ category }) => {
  let url = `/word`;
  const authToken = getToken();

  return await axios
    .get(`${API}${url}`, {
      params: { category },
      headers: { Authorization: `${BEARER} ${authToken}` }
    })
    .then((res) => res)
    .catch((err) => console.error(err));
};

export const postWord = async (word) => {
  let url = `/word`;
  const authToken = getToken();

  return await axios
    .post(`${API}${url}`, word, { headers: { Authorization: `${BEARER} ${authToken}` } })
    .then((res) => res)
    .catch((err) => console.error(err));
};

export const putWord = async (_id, word) => {
  let url = `/word/${_id}`;

  return await axios
    .put(`${API}${url}`, word)
    .then((res) => res)
    .catch((err) => console.error(err));
};

export const deleteWord = async (_id) => {
  let url = `/word/${_id}`;

  return await axios
    .delete(`${API}${url}`)
    .then((res) => res)
    .catch((err) => console.error(err));
};